package com.essntl.features.invoice.ui.addeditinvoice

import com.essntl.core.quickbooks.data.QuickbookSparseRequest
import com.essntl.core.quickbooks.data.QuickbooksInvoice
import com.essntl.features.paymentlink.domain.model.PaymentLinkModel
import com.essntl.features.service.domain.model.extraservice.ExtraServiceModel
import com.essntl.features.service.domain.model.service.ServiceModel

sealed interface AddEditInvoiceEvent {
    data class GetInvoice(val invoiceId: String?) : AddEditInvoiceEvent

    data class GetProposalItinerary(
        val proposalId: String,
        val itineraryId: String?,
    ) : AddEditInvoiceEvent

    data class CheckInitialServices(val invoiceId: String?) : AddEditInvoiceEvent

    data class CheckService(val id: String, val isChecked: Boolean) : AddEditInvoiceEvent

    data class CheckDayServices(val date: String, val isChecked: Boolean) : AddEditInvoiceEvent

    data class UpdateDueDateField(val dueDate: String) : AddEditInvoiceEvent

    data class SparseUpdateInvoice(val quickbookSparseRequest: QuickbookSparseRequest) : AddEditInvoiceEvent

    data class ToggleClientTravelAgent(val value: Boolean) : AddEditInvoiceEvent

    data class AddExtraService(
        val service: ServiceModel,
        val extraService: ExtraServiceModel,
    ) : AddEditInvoiceEvent

    data class RemoveExtraService(val id: String) : AddEditInvoiceEvent

    data object CloseQuickbooksRefreshWebpage : AddEditInvoiceEvent

    data class DeactivatePaymentLink(
        val paymentLink: PaymentLinkModel,
        val active: Boolean,
    ) : AddEditInvoiceEvent

    data class AddPaymentLink(
        val amount: Int,
        val paymentParameterIds: Set<String>,
    ) : AddEditInvoiceEvent

    /**
     * Invoice Events
     */
    data class DownloadInvoice(val qb: QuickbooksInvoice) : AddEditInvoiceEvent
    data object ClearDownloadInvoice : AddEditInvoiceEvent
    data object CreateUpdateInvoice : AddEditInvoiceEvent
}